module.exports = __webpack_public_path__ + "assets/img/dd0d1de12946e4441b6de7823966e3f0.jpg";